import Vue from 'vue'
import Vuex from 'vuex'

import axios from '@/axiosConnection'
import toastr from '@/toastr'

import app from './modules/app';
import auth from './modules/auth';
import user from './modules/user';
import warehouse from './modules/warehouse';
import storage_zone from './modules/storage_zone';
import storage_environment from './modules/storage_environment';
import storage_type from './modules/storage_type';
import company from './modules/company';
import company_contact from './modules/company_contact';
import company_group from './modules/company_group';
import company_type from './modules/company_type';
import calibration from './modules/calibration';
import certificate from './modules/certificate';
import equipment_group from './modules/equipment_group';
import external_maintenance from './modules/external_maintenance';
import price_type from './modules/price_type';
import price from './modules/price';
import reference_log from './modules/reference_log';
import reference from './modules/reference';
import spare_part from './modules/spare_part';
import status from './modules/status';
import agency from './modules/agency';
import agency_group from './modules/agency_group';
import business from './modules/business';
import employee from './modules/employee';
import renting from './modules/renting';
import renting_preparation from './modules/renting_preparation';
import renting_preparation_comment from './modules/renting_preparation_comment';
import renting_preparator from './modules/renting_preparator';
import business_return from './modules/business_return';
import transfer from './modules/transfer';
import transfer_reference from './modules/transfer_reference';
import shipping from './modules/shipping';
import shipping_reference from './modules/shipping_reference';
import complaint from './modules/complaint';
import myaxiloc_setting from './modules/myaxiloc_setting';
import axiloc_setting from './modules/axiloc_setting';
import transport_rate from './modules/transport_rate';
import request_attribute from './modules/request_attribute';
import fee_label from './modules/fee_label';
import location_for_account from './modules/location_for_account';
import faq from './modules/faq';
import stored_file from './modules/stored_file';
import internal_billing from './modules/internal_billing';
import manual_billing from './modules/manual_billing';
import product from './modules/product';
import product_log from './modules/product_log';
import popup from './modules/popup';
import theteam from './modules/theteam';
import tag from './modules/tag';
import table_pref from './modules/table_pref';

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV === 'development',
  modules: {
    app: app,
    auth: auth,
    user: user,
    warehouse: warehouse,
    table_pref: table_pref,
    storage_zone: storage_zone,
    storage_environment: storage_environment,
    storage_type: storage_type,
    company: company,
    company_contact: company_contact,
    company_group: company_group,
    company_type: company_type,
    calibration: calibration,
    certificate: certificate,
    equipment_group: equipment_group,
    external_maintenance: external_maintenance,
    price_type: price_type,
    price: price,
    reference_log: reference_log,
    reference: reference,
    spare_part: spare_part,
    status: status,
    agency: agency,
    agency_group: agency_group,
    business: business,
    employee: employee,
    renting: renting,
    renting_preparation: renting_preparation,
    renting_preparation_comment: renting_preparation_comment,
    renting_preparator: renting_preparator,
    business_return: business_return,
    transfer: transfer,
    transfer_reference: transfer_reference,
    shipping: shipping,
    shipping_reference: shipping_reference,
    complaint: complaint,
    myaxiloc_setting: myaxiloc_setting,
    axiloc_setting: axiloc_setting,
    transport_rate: transport_rate,
    request_attribute: request_attribute,
    fee_label: fee_label,
    location_for_account: location_for_account,
    stored_file: stored_file,
    internal_billing: internal_billing,
    manual_billing: manual_billing,
    product: product,
    product_log: product_log,
    faq: faq,
    popup: popup,
    theteam: theteam,
    tag: tag
  },
  mutations: {
    setItems(state, params) {
      if (params.items) {
        state[params.namespace].items = params.items
      }
    },
    /**
     * Remplace la liste comme setItems, mais garde les items déjà chargés plus complets (fiche
     * ouverte : prix, références…) que leur version de liste. Une seule affectation : la liste
     * peut compter plusieurs milliers d'items, à ne pas ajouter un par un.
     */
    mergeItems(state, params) {
      if (params.items) {
        const loaded = new Map(state[params.namespace].items.map(item => [item.id, item]))
        state[params.namespace].items = params.items.map(item => {
          const existing = loaded.get(item.id)
          return existing && Object.keys(existing).length > Object.keys(item).length ? existing : item
        })
      }
    },
    addItems(state, params) {
      if (params.items) {
        params.items.forEach(p => this.commit('addItem', {namespace: params.namespace, item: p}))
      }
    },
    setItem(state, params) {
      if (params.item) {
        state[params.namespace].items.splice(state[params.namespace].items.findIndex(i => i.id == params.item.id), 1, params.item)
      }
    },
    addItem(state, params) {
      let existingItem = state[params.namespace].items.find(item => item.id == params.item.id)
      if (!existingItem) {
        state[params.namespace].items.unshift(params.item)
      } else if (Object.keys(params.item).length > Object.keys(existingItem).length) {
        this.commit('setItem', params)
      }
    },
    saveItem(state, params) {
      state[params.namespace].items.splice(state[params.namespace].items.findIndex(i => i.id == params.item.id), 1, params.item)
    },
    deleteItem(state, params) {
      state[params.namespace].items = state[params.namespace].items.filter(item => item.id != params.id);
    }
  },
  actions: {
    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param {object}                  Paramètres
     *        {boolean}   wait          Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     *        {string}    api_url       Chemin racine de l'url à appeler
     *        {string}    api_data_path Chemain objet des données à charger dans le retour API
     *        {string}    namespace     Espace de nom du module store à l'origine de l'appel
     *        {integer}   limit         Nombre d'items demandés (0 = tous, valeur par défaut)
     * @returns promise                 Aucune donnée n'est retournée
     */
    getAll: (context, params) => {


      function objectResolve(obj, path) {
        path = path.split(".");
        var current = obj;
        while (path.length) {
          if (typeof current !== "object") return undefined;
          current = current[path.shift()];
        }
        return current;
      }

      return new Promise(function (resolve, reject) {
        if (params.wait == false && context.state[params.namespace].items && context.state[params.namespace].items.length) {
          resolve()
        }
        let query = params.query ? "&" + params.query : ''
        // `limit=0` signifie « tout » côté API : c'est le défaut historique, mais un appelant
        // peut n'en demander qu'une page (liste d'amorçage d'un autocomplete, par exemple).
        axios.get(params.api_url + "?limit=" + (params.limit || 0) + query)
          .then(response => {
            let p = {
              items: objectResolve(response.data, params.api_data_path),
              namespace: params.namespace
            }
            if (params.secondary_api_data_path) {
              p.items = p.items.concat(objectResolve(response.data, params.secondary_api_data_path))
            }
            if (params.add === true) {
              context.commit('addItems', p)
            } else if (params.merge === true) {
              context.commit('mergeItems', p)
            } else {
              context.commit('setItems', p)
            }
            resolve(response)
          })
          .catch(error => {
            toastr.error("Le chargement de la liste a échoué")
            reject(error)
          })
      })
    },
    /**
     * Charge un seul item via l'API dans le state. Si la donnée est déjà présente dans le state, le résolve() est lancé de suite
     * @param {object}                  Paramètres
     *        {boolean}   wait          Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     *        {string}    api_url       Chemin racine de l'url à appeler
     *        {string}    namespace     Espace de nom du module store à l'origine de l'appel
     *        {integer}   id            Id de l'item à charger
     * @returns promise                 Aucune donnée n'est retournée
     */
    getItem: (context, params) => {
      return new Promise(function (resolve, reject) {
        if (params.wait == false && context.state[params.namespace].items && context.state[params.namespace].items.length && context.state[params.namespace].items.find(item => item.id == params.id)) {
          resolve()
        }
        axios.get(params.api_url + "/" + params.id)
          .then(response => {
            let p = {
              item: response.data,
              namespace: params.namespace
            }
            if (params.add === true) {
              context.commit('addItem', p)
            } else {
              context.commit('setItem', p)
            }
            resolve(response)
          })
          .catch(error => {
            toastr.error("Le chargement de l'item a échoué")
            reject(error)
          })
      })
    },
    /**
     * Ajoute un item dans le state et via l'API.
     * @param {object}                  Paramètres
     *        {string}    api_url       Chemin racine de l'url à appeler
     *        {string}    namespace     Espace de nom du module store à l'origine de l'appel
     *        {object}    item          Item à créer
     *        {object}    formData      formData si souhaité, il sera alors envoyé à la place de item
     * @returns {promise}               Réponse de l'API ou l'erreur
     */
    addItem(context, params) {
      return new Promise(function (resolve, reject) {

        let data = params.formData || params.item

        axios.post(params.api_url, data)
          .then(response => {
            toastr.success("L'ajout s'est déroulé avec succès");
            let p = {
              item: {
                ...params.item,
                id: response.data.object.id
              },
              namespace: params.namespace
            }
            context.commit('addItem', p)
            if(!params.ignoreGetAll){
              context.dispatch(params.namespace + '/getItem', {
                id: response.data.object.id
              })
            }
            resolve(response)
          })
          .catch(error => {
            toastr.error("La création a échoué")
            if(error.response && error.response.data && error.response.data.errors){
              error.response.data.errors.forEach(error => {
                toastr.error(error.message)
              })
            }
            if(!params.ignoreGetAll){
              context.dispatch(params.namespace + '/getAll')
            }
            reject(error)
          })
      })
    },
    /**
     * Met à jour un item dans le state et via l'API.
     * @param {object}                  Paramètres
     *        {string}    api_url       Chemin racine de l'url à appeler
     *        {string}    namespace     Espace de nom du module store à l'origine de l'appel
     *        {object}    item          Item à mettre à jour (doit contenir une propriété 'id')
     *        {object}    formData      formData si souhaité, il sera alors envoyé à la place de item
     * @returns {promise}               Réponse de l'API ou l'erreur
     */
    saveItem(context, params) {
      return new Promise(function (resolve, reject) {
        let p = {
          item: params.item,
          namespace: params.namespace
        }
        context.commit('saveItem', p)

        let data = params.formData || params.item

        axios.patch(params.api_url + '/' + params.item.id, data)
          .then(response => {
            toastr.success("L'enregistrement s'est déroulé avec succès");
            if (response.data.status != 'deleted') {
              context.dispatch(params.namespace + '/getItem', {
                id: params.item.id
              })
            }
            resolve(response)
          })
          .catch(error => {
            if (error) {
              toastr.error("L'enregistrement a échoué")
              if(error.response && error.response.data && error.response.data.errors){
                error.response.data.errors.forEach(error => {
                  toastr.error(error.message)
                })
              }
              context.dispatch(params.namespace + '/getItem', {
                id: params.item.id
              })
              reject(error)
            }
          })
      })
    },
    /**
     * Supprime un item du state et via l'API.
     * @param {object}                  Paramètres
     *        {string}    api_url       Chemin racine de l'url à appeler
     *        {string}    namespace     Espace de nom du module store à l'origine de l'appel
     *        {integer}   id            Id de l'item à supprimer
     *        {boolean}   ignoreGetAll  true pour ignorer la requete de getAll à la suite du delete
     * @returns {promise}               Aucune donnée n'est retournée
     */
    deleteItem(context, params) {
      return new Promise(function (resolve, reject) {
        let p = {
          id: params.id,
          namespace: params.namespace
        }
        context.commit('deleteItem', p)
        axios.delete(params.api_url + '/' + params.id)
          .then(response => {
            toastr.success("La suppression s'est déroulée avec succès");
            if(!params.ignoreGetAll){
              context.dispatch(params.namespace + '/getAll')
            }
            resolve(response)
          })
          .catch(error => {
            toastr.error("La suppression a échoué")
            if(!params.ignoreGetAll){
              context.dispatch(params.namespace + '/getAll')
            }
            reject(error)
          })
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/stores/index.js